import React from 'react';
import { Icon } from 'merchant-portal-components';

const DeleteIcon = (props) => (
  <Icon
    className={`${props.type ? props.type : 'fal'} fa-trash-alt ${
      props.size ? props.size : ''
    }`}
    {...props}
  />
);

export default DeleteIcon;
